export default "__VITE_ASSET__DLu44vyW__"